@if ((settingsObservable | async); as settings) {
  <form
      [formGroup]="form"
      (submit)="onSubmit()"
      [ngClass]="{'has-errors': formErrors.identifier || formErrors.password}"
      [class.submitted]="submitted"
      autocomplete="off">
    <app-identifier-input [showErrors]="submitted"
                          [formErrors]="formErrors.identifier"
                          [settings]="settings"
                          [readonly]="showPassword"
                          (click)="onBackClicked()"
                          formControlName="identifier"/>
    @if (showPassword) {
      <app-password-input
          [canLogin]="canLogin"
          [sendOnInit]="sendOTP"
          [formErrors]="formErrors.password"
          [identifier]="getIdentifierField()?.value"
          formControlName="password"/>
    }
    <span class="invalid-msisdn hidden" id="js-msisdn-error"></span>
    <div class="form-group">
      <button class="btn btn-raised btn-block btn-primary">
        @if (!showPassword) {
          <span>{{ 'generic.button_next' | translate }}</span>
        }
        @if (showPassword) {
          <span>{{ 'generic.log_in' | translate }} <i class="icon icon-sign-in"></i></span>
        }
        @if (isLoading) {
          <i class="icon icon-spinner icon-spin"></i>
        }
      </button>
    </div>
    @if (showPassword) {
      <app-recaptcha-info/>
    }
  </form>
}
